import React from 'react';
import { formatEmptyField } from '../../../utils/emptyField';
import type { User } from '../types';

interface UserHeaderProps {
  user: User;
}

const UserHeaderComponent: React.FC<UserHeaderProps> = ({ user }) => {
  return (
    <h1 className="text-[28px] font-normal mb-6 text-gray-800 leading-tight">
      {formatEmptyField(user.firstName)} {formatEmptyField(user.lastName)}
      <small className="text-lg font-normal text-gray-600 ml-2">({formatEmptyField(user.emailAddress)})</small>
    </h1>
  );
};

UserHeaderComponent.displayName = 'UserHeader';

export const UserHeader = React.memo(UserHeaderComponent);
